import React from 'react';
import Link from 'next/link';

import cx from 'classnames';

import s from './CtaButton.module.css';

export interface CtaButtonProps {
  className?: string;
  style?: number;
  children?: string;
  href: string;
  title?: string;
}

interface ButtonProps extends CtaButtonProps {
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  title?: string;
}

const Button = React.forwardRef(
  (
    { className, href, children, style = 1, onClick, title }: ButtonProps,
    ref: React.Ref<HTMLAnchorElement>,
  ) => {
    return (
      <a
        className={cx(s.cta, className)}
        onClick={onClick}
        href={href}
        ref={ref}
        title={title}
      >
        <svg
          aria-hidden="true"
          className={cx(s.ctaOverlay, {
            [s.ctaOverlayStyle1]: style === 1,
            [s.ctaOverlayStyle2]: style === 2,
          })}
          viewBox="0 0 502 168"
        >
          <path d="M49.6896 32.9402C60.9399 23.9233 74.5451 18.9078 88.8807 17.0762C122.969 12.721 192.107 4.72898 259.411 2.00238C293.064 0.639044 326.246 0.592687 354.354 2.97287C382.488 5.35525 405.449 10.1631 418.728 18.4492C450.894 38.5212 478.757 58.4587 492.139 78.0575C498.821 87.8426 501.852 97.4853 500.069 106.988C498.285 116.495 491.662 125.976 478.785 135.388C472.389 140.063 462.353 144.285 449.441 148.007C436.539 151.726 420.805 154.936 403.045 157.607C367.526 162.95 323.936 166.134 278.751 166.941C188.358 168.555 91.6939 160.654 40.5349 141.552C21.1913 134.33 10.2195 125.499 5.05461 115.995C-0.100752 106.508 0.477704 96.2514 4.4557 86.0433C8.43744 75.8257 15.812 65.6978 24.1729 56.5392C32.5298 47.3851 41.8486 39.2247 49.6896 32.9402Z" />
        </svg>
        <div
          aria-hidden="true"
          className={cx(s.shape, {
            [s.shapeStyle1]: style === 1,
            [s.shapeStyle2]: style === 2,
          })}
        >
          <span className={cx(s.text)}>{children}</span>
        </div>
      </a>
    );
  },
);

Button.displayName = 'CtaButton';

const CtaButton = ({
  className,
  href,
  children,
  style = 1,
  title,
}: CtaButtonProps) => {
  return (
    <Link href={href} passHref legacyBehavior title={children}>
      {/* @ts-expect-error: NextJS injects href and onClick into Button component, so no need to pass them down */}
      <Button className={className} style={style} title={title}>
        {children}
      </Button>
    </Link>
  );
};

export { CtaButton };
